import {makeRequest, mergeAuthHeaders} from "./httpRequest";
import Config from "../core/config";
import {formatDateToAmericanFormat} from "./utils";
import Cookies from "js-cookie";
import {saveAs} from 'file-saver';

const { v4: uuidv4 } = require('uuid');

const apiUrl = Config.apiUrl;


export async function findProductsByQueryString(query) {
    try {
        const productsInLocalStorageJson = localStorage.getItem('products');
        if(productsInLocalStorageJson !== undefined) {
            const productssInLocalStorage = JSON.parse(productsInLocalStorageJson);
            if (productssInLocalStorage !== undefined && productssInLocalStorage !== null && productssInLocalStorage.length > 0) {
                return productssInLocalStorage;
            }
        }
        const url = apiUrl + '/api/products/query=' + (query && query !== '' ? query : '');
        const response: Product[] = await makeRequest(url, 'GET',
            {'Useruuid':Cookies.get('userUUID')});
        localStorage.setItem('products', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findAllProductsByQueryString(query) {
    try {
        const url = apiUrl + '/api/products/all/query=' + (query && query !== '' ? query : '');
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}
export async function findCustomersByQueryString(query) {
    try {
        const customerInLocalStorageJson = localStorage.getItem('customers');
        if(customerInLocalStorageJson !== undefined) {
            const customersInLocalStorage = JSON.parse(customerInLocalStorageJson);
            if (customersInLocalStorage !== undefined && customersInLocalStorage !== null && customersInLocalStorage.length > 0) {
                return customersInLocalStorage;
            }
        }
        const url = apiUrl + '/api/customers/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        localStorage.setItem('customers', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findEnabledCustomersByQueryString(query) {
    try {
        const enabledCustomersInLocalStorageJson = localStorage.getItem('enabledCustomers');
        if(enabledCustomersInLocalStorageJson !== undefined) {
            const enabledCustomersInLocalStorage = JSON.parse(enabledCustomersInLocalStorageJson);
            if (enabledCustomersInLocalStorage !== undefined && enabledCustomersInLocalStorage !== null && enabledCustomersInLocalStorage.length > 0) {
                return enabledCustomersInLocalStorage;
            }
        }
        const url = apiUrl + '/api/customers/enabled/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        localStorage.setItem('enabledCustomers', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findEnabledWalkInCustomersByQueryString(query) {
    try {
        const url = apiUrl + '/api/customers/enabled/walkin/query=' + (query && query !== '' ? (query) : '');
        return await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findWalkInCustomers() {
    const url = apiUrl + '/api/customers/walkin';
    return await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
}

export async function insertCustomer(customer) {
    const url = apiUrl + '/api/customers';
    return await makeRequest(url, 'POST', {
        'Content-Type': 'application/json',
        'Useruuid': Cookies.get('userUUID'),
    }, JSON.stringify(customer));
}

export async function updateCustomer(customer) {
    const url = apiUrl + '/api/customers';
    return await makeRequest(url, 'PUT', {
        'Content-Type': 'application/json',
        'Useruuid': Cookies.get('userUUID'),
    }, JSON.stringify(customer));
}

export async function findTablesByQueryString(query) {
    try {
        const tableInLocalStorageJson = localStorage.getItem('tables');
        if(tableInLocalStorageJson !== undefined) {
            const tablesInLocalStorage = JSON.parse(tableInLocalStorageJson);
            if (tablesInLocalStorage !== undefined && tablesInLocalStorage !== null && tablesInLocalStorage.length > 0) {
                return tablesInLocalStorage;
            }
        }
        const url = apiUrl + '/api/tables/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        localStorage.setItem('tables', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findEnabledTablesByQueryString(query) {
    try {
        const enabledTablesInLocalStorageJson = localStorage.getItem('enabledTables');
        if(enabledTablesInLocalStorageJson !== undefined) {
            const enabledTablesInLocalStorage = JSON.parse(enabledTablesInLocalStorageJson);
            if (enabledTablesInLocalStorage !== undefined && enabledTablesInLocalStorage !== null && enabledTablesInLocalStorage.length > 0) {
                return enabledTablesInLocalStorage;
            }
        }
        const url = apiUrl + '/api/tables/enabled/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        localStorage.setItem('enabledTables', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findUsersByQueryString(query) {
    try {
        const url = apiUrl + '/api/users/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}


export async function getRentalItem(id) {
    try {
        const url = apiUrl + '/api/rentalItem/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findRentalsByStringAndStatus(query, status) {
    try {
        if(!query) {
            query = '';
        }
        const url = apiUrl + '/api/productRented/findRentalsByStatus/query=' + query + '&status=' + status;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findPendingRentalItemItemByProductAvailability(productId) {
    try {
        const url = apiUrl + '/api/rentalItem/productId=' + productId;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}


export async function getProductById(id) {

    try {
        const url = apiUrl + '/api/products/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getSaleById(id) {

    try {
        const url = apiUrl + '/api/sales/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getReceivableById(id) {

    try {
        const url = apiUrl + '/api/receivables/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getCustomerById(id) {

    try {
        const url = apiUrl + '/api/customers/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getTableById(id) {

    try {
        const url = apiUrl + '/api/tables/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getSupplierById(id) {

    try {
        const url = apiUrl + '/api/suppliers/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getPaymentById(id) {

    try {
        const url = apiUrl + '/api/payments/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getWaitingListById(id) {

    try {
        const url = apiUrl + '/api/waitingList/id=' + id;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getProductRentalPriceByProductId(productId) {

    try {
        const url = apiUrl + '/api/product_rental_prices/productId=' + productId;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getAllPaymentMethods() {

    try {
        const url = apiUrl + '/api/paymentMethods';
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getAllCategories() {

    try {
        const url = apiUrl + '/api/categories';
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getPendingWaitingList(productId) {
    const url = `${apiUrl}/api/waitingList/productId=${productId ? productId : 0}`;
    return await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
}

export function getProductAvailability(productId, rentalId, days) {
    const url = `${apiUrl}/api/productAvailabilities/productId=${productId ? productId : 0}&rentalId=${rentalId}&days=${days}&currentDate=${formatDateToAmericanFormat(new Date())}`;
    return makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
}

export async function getProductAvailabilityFilterByQuantity(productId, rentalId, currentDate, days, quantity) {
    const url = `${apiUrl}/api/productAvailabilities/productId=${productId ? productId : 0}&rentalId=${rentalId}&days=${days}&currentDate=${formatDateToAmericanFormat(currentDate)}`;
    const availabilities = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
    return availabilities.filter((a) => a.quantity >= quantity)
}

export function getProductAvailabilityPerDate(productId, rentalId, days, currentDate, startDate, endDate, quantity) {
    const url = `${apiUrl}/api/productAvailabilities/filterByDate/productId=${productId ? productId : 0}&rentalId=${rentalId}&days=${days}&currentDate=${formatDateToAmericanFormat(currentDate)}&startDate=${formatDateToAmericanFormat(startDate)}&endDate=${formatDateToAmericanFormat(endDate)}&quantity=${quantity}`;
    return makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
}

export async function customerKeyExists(customerKey) {
    const url = apiUrl + '/api/customerKey/customerKey=' + customerKey;
    return makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
}

export async function userUUIDExists() {
    const url = apiUrl + '/api/users/userUUID';
    return makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
}

export async function getRentalById(id) {

    try {
        const url = apiUrl + '/api/rentals/id=' + id;
        return await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getCompanyByUserUUID() {

    try {
        const url = apiUrl + '/api/companies/userUUID';
        return await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function downloadContract(id, code) {
    try {
        const url = `${apiUrl}/api/contract/${id}`;
        const response = await fetch(url, {headers: mergeAuthHeaders({})});
        const data = await response.blob();

        saveAs(data, 'contrato_' + code + '.pdf');

    } catch (error) {
        console.error('Erro ao obter PDF:', error);
    }
}

export async function downloadDeliveryStatement(id, code) {
    try {
        const url = `${apiUrl}/api/deliveryStatement?id=${id}`;
        const response = await fetch(url, {headers: mergeAuthHeaders({})});
        const data = await response.blob();

        saveAs(data, 'termo_de_entrega_' + code + '.pdf');

    } catch (error) {
        console.error('Erro ao obter PDF:', error);
    }
}

export async function findCustomerPendingSale(customerString) {
    try {
        const url = apiUrl + '/api/sales/list-customer-pending-sale?customer-string=' + customerString;
        return await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findPendingSalesByCustomerId(customerId) {
    try {
        const url = apiUrl + '/api/sales/list-pending-sales-by-customer?customer-id=' + customerId;
        return await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findTablePendingSale(tableString) {
    try {
        const url = apiUrl + '/api/sales/list-table-pending-sale?table-string=' + tableString;
        return await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findPendingSalesByTableId(tableId) {
    try {
        const url = apiUrl + '/api/sales/list-pending-sales-by-table?table-id=' + tableId;
        return await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findPendingSalesByCustomerIdList(ids) {
    try {
        const url = `${apiUrl}/api/sales/list-pending-sales-by-customer-id-list?id-list=${ids.join(',')}`;
        return await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}


export async function findSalesPrinted() {
    try {
        const url = apiUrl + '/api/sales/sales-printed';
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}


export async function forceSalePrinting(ids) {
    try {
        const urlPay = apiUrl + '/api/sales/force-printing';
        await makeRequest(urlPay, 'PUT', {
            'Content-Type': 'application/json',
            'Useruuid': Cookies.get('userUUID'),
        }, JSON.stringify(ids));

    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findSalesByStatus(startDate, endDate, status) {
    try {
        const url = `${apiUrl}/api/sales/find-by-date-status-payed?startDate=${formatDateToAmericanFormat(startDate)}&endDate=${formatDateToAmericanFormat(endDate)}&status=${status}`;
        const response = await makeRequest(url, 'GET', {'Useruuid':Cookies.get('userUUID')});
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function insertSale(sale) {
    const userUUID = Cookies.get('userUUID');
    const url = apiUrl + '/api/sales';

    sale.uuid = uuidv4();
    await makeRequest(url, 'POST', {
        'Content-Type': 'application/json',
        'Useruuid': userUUID,
    }, JSON.stringify(sale));
}

export async function closeOrder(salesId, sale) {
    const url = apiUrl + '/api/sales/close';
    return await makeRequest(url, 'POST', {
        'Content-Type': 'application/json',
        'Useruuid': Cookies.get('userUUID'),
    }, JSON.stringify({salesId, sale}));
}

export async function updateSale(sale) {
    const url = apiUrl + '/api/sales';
    return await makeRequest(url, 'PUT', {
        'Content-Type': 'application/json',
        'Useruuid': Cookies.get('userUUID'),
    }, JSON.stringify(sale));
}